<template>
 <div  class="main"> 
  <div class="x-subnav">
 
     <xy-toolbox-menu class="l" :items="gainMenu" current="MADE价格指数"  />
      <div class="r action-btn-box" v-show="!viewResult">
        <el-button @click="onShowSelectDatetime"  type="primary" :disabled="searchResult.length==0"  class="actionBtn"  round > 生成数据 <svg-icon name="play" size="12" ></svg-icon> </el-button>
      </div>
     <xy-toolbox-menu class="r" v-show="viewResult">
       <xy-toolbox-menu-item icon="car_search" @click="goto()" >返回</xy-toolbox-menu-item>
       <xy-toolbox-menu-item icon="excel"  >Excel导出  </xy-toolbox-menu-item>
     </xy-toolbox-menu>
   </div>
<SearchBar :moduleName="currentModuleName" v-if="!viewResult"> 


 <el-collapse v-model="recentScheme" slot="defaultContent" v-if="false">
                 <el-collapse-item title="近期筛选方案" name="1"  >
                 <div class="recent-search-wrapper">
                  <el-row :gutter="12">
                    <el-col :span="6" v-for="(schemea,index) in savedSearchSchemas" :key="index"><SearchPlan :schemea="schemea"  @watchChild="showAdvancedSearchPanel" /></el-col>     
                  </el-row>
                 </div>
                </el-collapse-item>
           <el-collapse-item title="近期研究方案" name="2" >
            <div class="recent-research-wrapper">             
                <el-row :gutter="12">
                 
                </el-row>
            </div>
              </el-collapse-item>
            </el-collapse>
</SearchBar>

<div   v-if="viewResult" style="margin-top:20px;">
<el-row :gutter="0">
  <el-col :span="18" ><el-button type="primary" @click="goto">添加车款 </el-button>   <el-button type="primary">Excel导出</el-button>    </el-col>
  <el-col :span="6"></el-col>
</el-row>


</div>

 <el-dialog
            :visible.sync="showSelectDatetime"
            :center="false"
            :append-to-body="true" title="选择分析时间">
            <el-row :gutter="20">
           <el-col :span="24">         
              <span slot="dialog-title">选择分析时间</span>
               <el-date-picker  type="monthrange" v-model="daterange" :picker-options="pickerOptions" value-format="yyyy-MM"></el-date-picker> 
            </el-col>
          
 
</el-row>
       <span slot="footer">
                <el-button @click="onHideSelectDatetime">返回</el-button>
                <el-button @click="gotoAnalyze" type="primary">生成透视表</el-button>
            </span>
        </el-dialog>
 
</div>
</template>
<script>
import { mapMutations, mapGetters ,mapActions} from 'vuex';
import SearchBar from '@/components/common/NewSearchBar.vue';
import SearchPlan from '@/components/search/SearchPlan.vue';
import ResearchPlan from '@/components/search/ResearchPlan.vue';
import GUID from  '../store/guid';
export default {
    name: 'saleanalysis',
       components: {SearchBar},
    data(){
        return {
              recentScheme:['1','2'],
             
            viewResult:false,
            showSelectDatetime:false,
            currentModuleName:'SaleAnalysis',
             dataSource:'乘联会销量管理',
             daterange:null,
          pickerOptions: {
          shortcuts: [{
            text: '本月',
            onClick(picker) {
              picker.$emit('pick', [new Date(), new Date()]);
            }
          }, {
            text: '今年至今',
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().getFullYear(), 0);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近二个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 2);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 3);
              picker.$emit('pick', [start, end]);
            }
          },{
            text: '最近六个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 6);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        }
    },
     methods: {
         
           ...mapMutations('commonsearch', ['setPivotTableKey' ,'clearSearch' ]),
           ...mapActions('commonsearch', ['savePivotTableAsync' ,'getSaleCategories' ]),
           onShowSelectDatetime(){
            this.showSelectDatetime = true;
        },
        onHideSelectDatetime()
        {
             this.showSelectDatetime = false;
        },
         goto(){
     
           this.viewResult = !this.viewResult;
         },
         showAdvancedSearchPanel(){},      
       // 进入分析
        gotoAnalyze() {
                if(this.daterange == null)
                {
                     this.$message({
                    type: 'error',
                    message: '没有选择日期',
                    duration: 2000,
                });
                    return ;
                }

                 var key = new GUID().newGUID();
                this.savePivotTableAsync({key:key ,cb:this.gotoPivotTable });

        },
        gotoPivotTable(key)
        {
              this.$router.push({
                name: 'flexmonster',
                query: {
                    datatype: 'gain',
                    pivotTableKey:key,
                    daterange:this.daterange,
                    source: this.dataSource
                }
            });
        }
     },
     computed:{
          ...mapGetters('commonsearch', {'saleCategories':'saleCategories',
            'savedSearchSchemas':'savedSearchSchemas',
             'searchResult': 'selectionResult'
            }),
     },
    mounted() {
           this.clearSearch();
           this.getSaleCategories({cb:null});

    },
    watch:{
      saleCategories(newVale)
      {
        
      }
    }
    
}
</script>
<style>
</style>